/**
 * @generated SignedSource<<867e33ed0b0cfa0b3a95b41e7f6cc3e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PolicyRestrictionsGuardRefetchableFragment$variables = {
  buys: boolean;
  inWebView: boolean;
  sends: boolean;
};
export type PolicyRestrictionsGuardRefetchableFragment$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"PolicyRestrictionsGuardFragment">;
  } | null;
};
export type PolicyRestrictionsGuardRefetchableFragment = {
  response: PolicyRestrictionsGuardRefetchableFragment$data;
  variables: PolicyRestrictionsGuardRefetchableFragment$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buys"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inWebView"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sends"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "restrictionName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Link",
    "kind": "LinkedField",
    "name": "link",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  },
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PolicyRestrictionsGuardRefetchableFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "buys",
                "variableName": "buys"
              },
              {
                "kind": "Variable",
                "name": "inWebView",
                "variableName": "inWebView"
              },
              {
                "kind": "Variable",
                "name": "sends",
                "variableName": "sends"
              }
            ],
            "kind": "FragmentSpread",
            "name": "PolicyRestrictionsGuardFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PolicyRestrictionsGuardRefetchableFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProperties",
            "kind": "LinkedField",
            "name": "userProperties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "inWebView",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isWebview2faEligible",
                "storageKey": null
              }
            ]
          },
          {
            "condition": "sends",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "sendRestrictions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "sends"
                  }
                ],
                "concreteType": "PolicyRestriction",
                "kind": "LinkedField",
                "name": "policyRestrictions",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": "policyRestrictions(action:\"sends\")"
              }
            ]
          },
          {
            "condition": "buys",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "buyRestrictions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "buys"
                  }
                ],
                "concreteType": "PolicyRestriction",
                "kind": "LinkedField",
                "name": "policyRestrictions",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": "policyRestrictions(action:\"buys\")"
              }
            ]
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81128f799b55acedab5bb495c6705253",
    "id": null,
    "metadata": {},
    "name": "PolicyRestrictionsGuardRefetchableFragment",
    "operationKind": "query",
    "text": "query PolicyRestrictionsGuardRefetchableFragment(\n  $buys: Boolean!\n  $inWebView: Boolean!\n  $sends: Boolean!\n) {\n  viewer {\n    ...PolicyRestrictionsGuardFragment_KfpDY\n    id\n  }\n}\n\nfragment PolicyRestrictionsGuardFragment_KfpDY on Viewer {\n  userProperties {\n    uuid\n    country {\n      code\n      name\n    }\n    id\n  }\n  isWebview2faEligible @include(if: $inWebView)\n  sendRestrictions: policyRestrictions(action: sends) @include(if: $sends) {\n    restrictionName\n    link {\n      url\n      text\n    }\n    description\n    message\n    id\n  }\n  buyRestrictions: policyRestrictions(action: buys) @include(if: $buys) {\n    restrictionName\n    link {\n      url\n      text\n    }\n    description\n    message\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ce67022e15e22e6e3c216e7fc3b8f3c";

export default node;
